import TableColumn from "@component/common/TableColumn";
import TableHeader from "@component/common/TableHeader";
import { CHALLENGE_MISSION_INFO } from "@constant/CHALLENGE_MISSION_INFO";

export default function ChallengeMissionColumn() {
  return (
    <TableHeader>
      {CHALLENGE_MISSION_INFO.map(({ COLUMN, WIDTH }, index) => {
        return (
          <TableColumn key={index} width={WIDTH}>
            {COLUMN}
          </TableColumn>
        );
      })}
    </TableHeader>
  );
}
